import { useCallback } from 'react'
import { useScheduleDetailsOptional } from '@/features/scheduleDetails/useScheduleDetails'
import { usePulseDemoStore } from '@/features/pulseDemo/pulseDemoStore'
import { usePulseUiStore } from './pulseUiStore'

/** Open a Pulse item in the side panel; the schedule panel closes so only one shows. */
export function useOpenPulseItem() {
  const schedule = useScheduleDetailsOptional()
  const closeSchedule = schedule?.closeSchedule
  return useCallback(
    (kind, id) => {
      closeSchedule?.()
      usePulseUiStore.getState().openItem(kind, id)
    },
    [closeSchedule],
  )
}

/** Open a run result and mark it read. */
export function useOpenUpdate() {
  const openItem = useOpenPulseItem()
  return useCallback(
    (id) => {
      usePulseDemoStore.getState().markRead(id)
      openItem('update', id)
    },
    [openItem],
  )
}
